// @ts-nocheck
export function initializeGTM(id: string): void {
  (function (w, d, s, l, i): void {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start':
        new Date().getTime(), event: 'gtm.js',
    });
    const f = d.getElementsByTagName(s)[0],
      j = d.createElement(s), dl = l !== 'dataLayer' ? `&l=${l}` : '';
    (<any>j).async = true;
    (<any>j).src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', id);
}
